module.exports = __webpack_public_path__ + "media/img/wedding_success/crew-4695385efe4658ca523dbd1b536ba74d.png";